import { GoogleMap, withGoogleMap, withScriptjs } from "react-google-maps";
import * as React from "react";
import { compose, withProps } from "recompose";
import Marker from "react-google-maps/lib/components/Marker";
import googleMaps from "../api/googleMaps";
import DirectionsRenderer from "react-google-maps/lib/components/DirectionsRenderer";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import StandaloneSearchBox from "react-google-maps/lib/components/places/StandaloneSearchBox";
import MoneyLabel from "./MoneyLabel";
import NumberFormat from "react-number-format";
import DirectionsResult = google.maps.DirectionsResult;
import PlaceResult = google.maps.places.PlaceResult;
import DirectionsLeg = google.maps.DirectionsLeg;
import DirectionsRoute = google.maps.DirectionsRoute;
import LatLngBounds = google.maps.LatLngBounds;
import { ConfigData } from "../config";
import { getApi } from "../api/ApiProvider";
import { BranchData } from "./BranchSelector";
import { Client, Driver } from "src/api/model";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import { SortDirection } from "@material-ui/core/TableCell";
import { ColumnDefinition } from "../components/AsyncTable";
import { format } from "date-fns";
import { AddLocation } from "@material-ui/icons";
import { Link } from "react-router-dom";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ClearAll from "@material-ui/icons/ClearAll";
import LocationSeraching from "@material-ui/icons/LocationSearching";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";



// import { DateTimePicker } from "material-ui-pickers";

export class Dot {
  lat: number;
  lng: number;

  constructor(latitude: number, longitude: number) {
    this.lat = latitude;
    this.lng = longitude;
  }
}

const StepIndicator = ({ step }: { step: number }) => (
  <Typography
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '24px',
      height: '24px',
      borderRadius: '50%',
      backgroundColor: '#1976d2',
      color: 'white',
      fontSize: '14px',
      fontWeight: 'bold',
      marginRight: '8px',
      marginTop: '2px'
    }}
  >
    {step}
  </Typography>
);

interface VisitsDetail {
  id?: number;
  client: Client | undefined;
  location: Dot;
  visitDateTime: string | undefined;
  observations?: string;
  order?: number;
  street1?: string;
}
export interface RouteData {
  newAddress?: boolean;
  order?: string;
  observations?: string;
  visitDateTimeSchedule?: string | undefined;
  visitDateTime?: string | undefined;
  destiny?: Dot;
  destinyStreet?: string;

  distance?: number;
  price?: number;
  duration?: string;
  fullData?: DirectionsResult;
  route?: DirectionsRoute;
  leg?: DirectionsLeg;
  searchBounds?: LatLngBounds;
  selectedDriver?: Driver | undefined;
  selectedClient?: Client | undefined;
  selectedLoc?: any;
  // Driver data
  visitsDetail?: VisitsDetail[] | undefined;
  drivers?: Driver[];
  selectedVehicle?: any;
  vehicleId?: number;
  // Client data
  clients?: Client[];
  locations?: any[];

  // Client document
  clientDocument?: string;
  clientLocations?: LocationData[];
  selectedClientLocationId?: string;
  selectedClientLocation?: LocationData;

  // Branch data used as origin
  selectedBranch?: BranchData;
  branchList?: BranchData[];
  limit?: number
}

export interface RouteSelectorProps {
  data?: RouteData;
  config: ConfigData;
  onNewData: (data: RouteData) => void;
  sendData: (data: any) => void;
}

type MarkerType = "origin" | "destiny";

interface RouteSelectorState {
  dialogOpen: boolean;
  totalItems: number;
  pageNum: number;
  pageSize: number;
  table: {
    data: any;
    sortBy: string;
    sortDirection: SortDirection;
    columnData: ColumnDefinition[];
  };
  filterLoc: string;
  filter: string;
  filterVehicle: string;
  isDialogOpenLoc: boolean;
  isDialogOpenClient: boolean;
  isDialogOpen: boolean;
  isDialogOpenVehicle: boolean;
  data: RouteData;
  line?: string;
  center: Dot;
  confirmarOrdenFlag: boolean;
}

interface MapProps {
  zoom: number;
  center: Dot;
  origin?: Dot;
  destiny?: any;
  directions: any;

  handleOnClick(e: google.maps.MouseEvent | google.maps.IconMouseEvent): void;

  handleDragEnd(
    whichOne: string,
    index?: number
  ): (e: google.maps.MouseEvent) => void;
}

export interface LocationData {
  id: number;
  lat: number;
  lng: number;

  street1: string;
  client: {
    user: { name: string; email: string };
    phone: string;
  };
}

const RouteMap: React.SFC<MapProps> = (props: MapProps) => {
  const { center, zoom, destiny, handleDragEnd, handleOnClick, directions } =
    props;
  return (
    <GoogleMap defaultZoom={zoom} center={center} onClick={handleOnClick}>
      {destiny &&
        destiny.length > 0 &&
        destiny.map((item: VisitsDetail, index: number) => (
          <Marker
            draggable
            onDragEnd={handleDragEnd("destiny", index)}
            position={item.location}
            label={{ text: "V" + item.order, color: "white" }}
            key={item.id}
          />
        ))}

      {directions && (
        <DirectionsRenderer
          directions={directions}
          defaultOptions={{ suppressMarkers: true }}
        />
      )}
    </GoogleMap>
  );
};

const EnhancedMap = compose<MapProps, MapProps>(
  withProps({
    containerElement: <div style={{ height: "400px" }} />,
    mapElement: <div style={{ height: "400px" }} />,
  }),
  withGoogleMap
)(RouteMap);

class RouteSelectorVisit extends React.Component<
  RouteSelectorProps,
  RouteSelectorState
> {
  refOrigin: StandaloneSearchBox;
  refDestiny: StandaloneSearchBox;

  inputRef: React.RefObject<HTMLInputElement>;

  constructor(props: RouteSelectorProps) {
    super(props);

    this.state = {
      dialogOpen: false,
      totalItems: 100,
      pageNum: 0,
      pageSize: 3,
      table: {
        data: [],
        sortBy: "order",
        sortDirection: "asc",
        columnData: [
          {
            path: "client.user.name",
            label: "Cliente",
            numeric: false,
          },
          {
            path: "visitDateTime",
            label: "Fecha",
            numeric: false,
          },
          {
            path: "observations",
            label: "Observaciones",
            numeric: false,
            draw: (cd: ColumnDefinition, data: VisitsDetail) => {
              return (
                <TextField
                  id="observations"
                  placeholder="Observaciones"
                  multiline
                  rows={3}
                  value={data.observations}
                  onChange={(event) =>
                    this.handleObservationsChange(event, data)
                  }
                  style={{
                    width: "90%",
                  }}
                  margin="normal"
                />
              );
            },
          },
          {
            path: "order",
            label: "Orden",
            numeric: false,
            draw: (cd: ColumnDefinition, data: VisitsDetail) => {
              return (
                <TextField
                  id="order"
                  placeholder="Orden"
                  type="text"
                  value={data.order}
                  onChange={(event) => this.handleOrderChange(event, data)}
                  style={{
                    width: "90%",
                  }}
                  margin="normal"
                />
              );
            },
          },
          {
            path: "",
            numeric: true,
            label: "Acciones",
            draw: (cd: ColumnDefinition, data: VisitsDetail) => {
              return (
                <div>
                  <IconButton
                    aria-label="Visitados"
                    title="Visitados"
                    onClick={() =>
                      data.client && this.handleClickRemove(data && data.id ? data.id : 0)
                    }
                  >
                    <DeleteIcon />
                  </IconButton>
                </div>
              );
            },
          },
        ],
      },
      filterLoc: "",
      filter: "",
      filterVehicle: "",
      isDialogOpen: false,
      isDialogOpenLoc: false,
      isDialogOpenClient: false,
      isDialogOpenVehicle: false,
      data: {
        destinyStreet: "",
        clientDocument: "",
        clientLocations: [],
        visitsDetail: [],
        ...props.data,
        limit: 200,
      },
      center: props.config.maps.startingLocation,
      confirmarOrdenFlag: false,

    };

    this.onOriginMounted = this.onOriginMounted.bind(this);
    this.onDestinyMounted = this.onDestinyMounted.bind(this);

    this.handleOnClick = this.handleOnClick.bind(this);
    this.handleDragEnd = this.handleDragEnd.bind(this);
    this.fireNewDataEvent = this.fireNewDataEvent.bind(this);

    // this.requestNewDirections = this.requestNewDirections.bind(this);
    this.getRouteDescription = this.getRouteDescription.bind(this);
    this.handleKeyPressInDocument = this.handleKeyPressInDocument.bind(this);
    this.onChangeClientLocationSelect =
      this.onChangeClientLocationSelect.bind(this);
    this.onChangeBranchSelector = this.onChangeBranchSelector.bind(this);

    this.onChangeClientLocationSelect2 =
      this.onChangeClientLocationSelect2.bind(this);

    this.obtenerUbicaciones = this.obtenerUbicaciones.bind(this);
    this.selectLocation = this.selectLocation.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleDialogClose = this.handleDialogClose.bind(this);
    this.calculateWaypoints = this.calculateWaypoints.bind(this);
    this.reordenateOrder = this.reordenateOrder.bind(this);
    this.cleanOrder = this.cleanOrder.bind(this);
    this.reorganizateOrder = this.reorganizateOrder.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);

    this.obtenerUbicaciones(this.state.pageNum, this.state.pageSize);
    this.obtenerDrivers();
  }
  obtenerDrivers() {
    getApi().driver().listActiveByAdmin().then((data: Driver[]) => {
      this.setState({
        data: {
          ...this.state.data,
          drivers: data
        }
      });
    }
    );
  }
  obtenerUbicaciones(pageNum: number, pageSize: number) {
    // getApi().client().locations().then((data: any[]) => {
    getApi()
      .client()
      .locations(pageNum, pageSize, this.state.filter, this.state.filterLoc)
      .then((data: any) => {
        console.log(data);
        const fech = new Date();
        this.setState({
          data: {
            ...this.state.data,
            locations: data.page,
            visitDateTimeSchedule: format(fech, "YYYY-MM-DD HH:mm"),
          },
          totalItems: data.totalElements,
        });
      });
  }

  // No esta actualizando el cambio en el orden
  handleOrderChange = (event: any, data: any) => {
    let newVisitDetail: any = [];
    if (this.state.data && this.state.data.visitsDetail) {
      newVisitDetail = this.state.data.visitsDetail;
      newVisitDetail.forEach((item: any) => {
        if (item.id === data.id) {
          const newValue = event.target.value;
          const isValueUsed = newVisitDetail.some((otherItem: any) => otherItem.id !== data.id && otherItem.order === newValue);
          const previousItem = newVisitDetail.find((otherItem: any) => otherItem.order === item.order - 1);
          if (!isValueUsed && (!previousItem || newValue > previousItem.order) && newValue <= newVisitDetail.length) {
            item.order = newValue;
          }
        }
      });

      this.setState({
        data: {
          ...this.state.data,
          visitsDetail: newVisitDetail,
        },
      });
    }
  };

  handleObservationsChange = (event: any, data: any) => {
    let newVisitsDetail = [];
    if (this.state.data && this.state.data.visitsDetail) {
      newVisitsDetail = this.state.data.visitsDetail;
      newVisitsDetail.forEach((item: any) => {
        if (item.id === data.id) {
          item.observations = event.target.value;
        }
      });
      this.setState({
        data: {
          ...this.state.data,
          visitsDetail: newVisitsDetail,
        },
      });
    }
  };

  handleOnClick(args: google.maps.MouseEvent | google.maps.IconMouseEvent) {
    if (!this.state.data.destiny) {
      this.setState({
        ...this.state,
        data: {
          ...this.state.data,
          destiny: new Dot(args.latLng.lat(), args.latLng.lng()),
        },
      });
      this.fireNewDataEvent(true);
      return;
    }
  }

  async requestNewDirections(forceRename: boolean) {
    // if (this.state.data.destiny) {
    //     try {
    //         const data: DirectionsResult = await googleMaps.getDirections(this.state.data.origin,
    //             this.state.data.destiny, this.props.config.maps.region);
    //         this.handleDirectionsData(data, forceRename);
    //         console.log("se pidieron nuevas direcciones:" + data);
    //     } catch (err) {
    //         console.log(err);
    //         this.setState({
    //             data: {
    //                 ...this.state.data,
    //                 distance: undefined,
    //                 duration: undefined,
    //                 fullData: undefined,
    //                 price: undefined
    //             }
    //         });
    //     }
    // }
  }

  handleDirectionsData(data: DirectionsResult, forceNewPosition = true) {
    const route = data && data.routes && data.routes[0];

    const leg = route && route.legs && route.legs[0] && route.legs[0];

    if (!leg) {
      return;
    }

    this.setState({
      data: {
        ...this.state.data,
        // originStreet: forceNewPosition ? leg.start_address : this.state.data.originStreet || leg.start_address,
        destinyStreet: forceNewPosition
          ? leg.end_address
          : this.state.data.destinyStreet || leg.end_address,
        fullData: data,
        leg: leg,
        route: route,
        distance: leg.distance.value,
        duration: leg.duration.text,
        price: (leg.distance.value / 1000) * this.props.config.races.pricePerKm,
      },
    });
  }

  getRouteDescription() {
    const data = this.state.data;
    if (!data.fullData) {
      return (
        <Typography>
          Seleccione dos puntos para iniciar el calculo de ruta
        </Typography>
      );
    }

    return (
      <Typography>
        El viaje es de:{" "}
        <NumberFormat
          value={(data.distance || 0) / 1000}
          suffix={"Km."}
          displayType={"text"}
          decimalScale={4}
        />{" "}
        , y costará aproximadamente <MoneyLabel amount={data.price} />.
      </Typography>
    );
  }

  handleDragEnd(marker: MarkerType, index?: number) {
    return (e: google.maps.MouseEvent) => {
      if (index !== undefined && this.state.data.visitsDetail) {
        this.setState((prevState) => {
          const visitsDetail = prevState.data.visitsDetail
            ? [...prevState.data.visitsDetail]
            : [];
          visitsDetail[index].location = new Dot(
            e.latLng.lat(),
            e.latLng.lng()
          );

          return {
            data: {
              ...prevState.data,
              visitsDetail,
            },
          };
        });
      }
      this.setState({
        data: {
          ...this.state.data,
          [marker]: new Dot(e.latLng.lat(), e.latLng.lng()),
        },
      }, () => this.calculateWaypoints());
      this.fireNewDataEvent(true);
    };
  }

  fireNewDataEvent(forceRename: boolean) {
    if (this.state.data.destiny) {
      // this.requestNewDirections(forceRename).then(() => {
      //     this.props.onNewData(this.state.data);
      // });
    }
  }

  setNewPlace(ref: StandaloneSearchBox, type: MarkerType) {
    const places: PlaceResult[] = ref.getPlaces();
    console.log(places, "places");
    const bounds = new google.maps.LatLngBounds();

    places.forEach((place: PlaceResult) => {
      if (place.geometry.viewport) {
        bounds.union(place.geometry.viewport);
      } else {
        bounds.extend(place.geometry.location);
      }
    });

    const nextMarkers = places.map((place: PlaceResult) => ({
      position: place.geometry.location,
    }));
    const nextCenter =
      (nextMarkers && nextMarkers[0] && nextMarkers[0].position) ||
      this.state.center;
    const centerDot = new Dot(nextCenter.lat(), nextCenter.lng());

    this.setState({
      data: {
        ...this.state.data,
        [type]: centerDot,
      },
      center: centerDot,
    });
    this.setVisitDetail(places[0].formatted_address);
    this.fireNewDataEvent(true);
  }

  setVisitDetail(address: string = "") {
    if (
      this.state.data.destiny &&
      this.state.data.selectedClient &&
      this.state.data.visitDateTime
    ) {
      if (this.state.data.visitsDetail) {
        const lat = this.state.data.destiny.lat;
        const lng = this.state.data.destiny.lng;
        const valorRepetido = this.state.data.visitsDetail.some(
          (item: any) => item.id === lat + lng
        );
        console.log(valorRepetido);
        if (valorRepetido) {
          alert("Ubicación ya seleccionada");
          this.setState({
            data: {
              ...this.state.data,
              destiny: undefined,
              destinyStreet: "",
              selectedClient: undefined,
              newAddress: false,
            },
          });
          return;
        }
      }
      const newVisitDetail: VisitsDetail = {
        id: this.state.data.destiny.lat + this.state.data.destiny.lng,
        client: this.state.data.selectedClient,
        location: this.state.data.destiny,
        visitDateTime: this.state.data.visitDateTime,
        observations: this.state.data.observations,
        order: this.state.data.visitsDetail
          ? this.state.data.visitsDetail.length + 1
          : 1,
        street1: address,
      };
      this.setState({
        data: {
          ...this.state.data,
          visitsDetail: [
            newVisitDetail,
            ...(this.state.data.visitsDetail || []),
          ],
        },
      });
      this.setState({
        data: {
          ...this.state.data,
          destiny: undefined,
          destinyStreet: "",
          selectedClient: undefined,
        },
      });
    }
  }

  onPlaceSelected(type: MarkerType) {
    return () => {
      this.setNewPlace(
        type === "origin" ? this.refOrigin : this.refDestiny,
        type
      );
    };
  }

  onOriginMounted(ref: StandaloneSearchBox) {
    this.refOrigin = ref;
    this.getSearchRegionBounds();
    this.getBranchList();
  }

  onDestinyMounted(ref: StandaloneSearchBox) {
    this.refDestiny = ref;
  }

  async getSearchRegionBounds() {
    const bounds: LatLngBounds = await googleMaps.getGeoCodeBounds(
      this.props.config.maps.region
    );
    this.setState({
      data: {
        ...this.state.data,
        searchBounds: bounds,
      },
    });
  }

  getLocationsByClientDocument(document: string) {
    getApi()
      .admin()
      .clientLocationByDocument(document)
      .then((data) => {
        this.setState({
          data: {
            ...this.state.data,
            clientLocations: data,
          },
        });
      })
      .catch((error) => {
        this.setState({
          data: {
            ...this.state.data,
            clientLocations: undefined,
            selectedClientLocation: undefined,
            selectedClientLocationId: undefined,
          },
        });
      });
  }

  handleKeyPressInDocument(e: React.KeyboardEvent<any>) {
    if (e.key === "Enter") {
      if (this.state.data.clientDocument) {
        this.getLocationsByClientDocument(this.state.data.clientDocument);
      }
    }
  }

  onChangeClientLocationSelect(e: any) {
    const location = this.getClientLocationByName(e.target.value);
    if (location) {
      console.log(location);
      this.setState(
        {
          data: {
            ...this.state.data,
            selectedClientLocationId: e.target.value,
            selectedClientLocation: location,
            destiny: new Dot(location.lat, location.lng),
            destinyStreet: location.street1,
          },
          center: new Dot(location.lat, location.lng),
        },
        () => {
          if (
            this.state.data.destiny &&
            this.state.data.selectedClient &&
            this.state.data.visitDateTime
          ) {
            const newVisitDetail: VisitsDetail = {
              id: this.state.data.destiny.lat + this.state.data.destiny.lng,
              client: this.state.data.selectedClient,
              location: this.state.data.destiny,
              visitDateTime: this.state.data.visitDateTime,
              observations: "",
              order: 0,
            };
            this.setState({
              data: {
                ...this.state.data,
                visitsDetail: [
                  newVisitDetail,
                  ...(this.state.data.visitsDetail || []),
                ],
              },
            });
            this.setState({
              data: {
                ...this.state.data,
                visitDateTime: "",
                destiny: undefined,
                destinyStreet: "",
                selectedClient: undefined,
              },
            });
          }
        }
      );
    }

    console.log(`selectedClientLocation--> ${this.state.data.destinyStreet}`);
    console.log(`selectedClientLocation--> ${this.state.data.destiny}`);
  }

  getClientLocationByName(id: string): LocationData | undefined {
    const nid = Number(id);
    if (this.state.data.clientLocations) {
      const loc = this.state.data.clientLocations.find((l) => l.id === nid);

      return loc ? loc : undefined;
    }
    return undefined;
  }

  getBranchList() {
    getApi()
      .branch()
      .listAllBranchesAdmin()
      .then((data) => {
        this.setState(
          {
            data: {
              ...this.state.data,
              branchList: data,
            },
          },
          () => {
            // default first branch selection
            this.setBranch(0);
          }
        );
      });
  }

  onChangeBranchSelector(e: React.ChangeEvent<any>) {
    const idx = +e.target.value;
    this.setBranch(idx);
  }

  setBranch(idx: number) {
    const branch = this.state.data.branchList
      ? this.state.data.branchList[idx]
      : undefined;
    // const origin = this.state.data.origin
    console.log(idx);
    this.setState({
      data: {
        ...this.state.data,
        selectedBranch: branch,
        // origin: branch?new Dot(branch.location.lat, branch.location.lng ):origin
      },
    });
  }

  onChangeClientLocationSelect2(index: number) {
    console.log(index);
    if (index < 0) {
      this.setState({
        data: {
          ...this.state.data,
          selectedClientLocation: undefined,
          selectedClientLocationId: undefined,
        },
      });
    }

    const location =
      this.state.data.clientLocations && this.state.data.clientLocations[index];
    if (location && index >= 0) {
      this.setState(
        {
          data: {
            ...this.state.data,
            selectedClientLocationId: index.toString(),
            selectedClientLocation: location,
            destinyStreet: location.street1,
            destiny: new Dot(location.lat, location.lng),
          },
          center: new Dot(location.lat, location.lng),
        },
        () => this.fireNewDataEvent(true)
      );
    }
  }

  selectDriver(driver: Driver) {
    console.log("asd");
    this.setState({
      isDialogOpen: false,
      data: {
        ...this.state.data,
        selectedDriver: driver,
      },
    });
  }

  selectVehicle(vehicle: any) {
    this.setState({
      data: {
        ...this.state.data,
        selectedVehicle: vehicle,
        vehicleId: vehicle.id
      },
      isDialogOpenVehicle: false,
      filterVehicle: ''
    });
  }
  selectLocation(loc: any) {

    this.setState({ filterLoc: "" });
    const client = this.state.data.clients ? this.state.data.clients.find((c: Client) => c.id === loc.clientId)
      : loc.client;
    if (this.state.data.visitsDetail) {
      const valorRepetido = this.state.data.visitsDetail.some(
        (item: any) => item.id === loc.lat + loc.lng
      );
      console.log(valorRepetido);
      if (loc.street1 === "" || loc.street1 === undefined || loc.street1 === null) {
        alert("Cliente sin dirección establecida,registre una nueva direccion para el cliente");
        return;
      }

      if (valorRepetido) {
        alert("El cliente ya fue seleccionado");
        return;
      }
    }

    this.setState(
      {
        isDialogOpenClient: false,
        data: {
          ...this.state.data,
          selectedLoc: loc,
          selectedClient: client,
          destinyStreet: loc.street1,
          destiny: new Dot(loc.lat, loc.lng),
        },
        center: new Dot(loc.lat, loc.lng),
      },
      () => {
        if (
          this.state.data.destiny &&
          (this.state.data.selectedClient || client) &&
          this.state.data.visitDateTime
        ) {
          if (!this.state.data.selectedClient) {
            this.setState({
              data: {
                ...this.state.data,
                selectedClient: client,
              },
            });
          }
          const newVisitDetail: VisitsDetail = {
            id: this.state.data.destiny.lat + this.state.data.destiny.lng,
            client: this.state.data.selectedClient || client,
            location: this.state.data.destiny,
            visitDateTime: this.state.data.visitDateTime,
            observations: "",
            order: this.state.data.visitsDetail
              ? this.state.data.visitsDetail.length + 1
              : 1,
          };

          this.setState(
            {
              data: {
                ...this.state.data,
                visitsDetail: [
                  ...(this.state.data.visitsDetail || []),
                  newVisitDetail,
                ],
              },
            },
            () => {
              this.setState({
                data: {
                  ...this.state.data,
                  destiny: undefined,
                  destinyStreet: "",
                  selectedClient: undefined,
                },
              });

              this.calculateWaypoints();
            }
          );
        }
        console.log(this.state.data.visitsDetail && this.state.data.visitsDetail.length ? this.state.data.visitsDetail.length : "No hay visitas");

      }

    );
    // this.getLocationsByClientDocument(client.document);
  }
  calculateWaypoints(optimized: boolean = false) {
    if (this.state.data.visitsDetail && this.state.data.visitsDetail.length >= 1) {
      const directionsService = new google.maps.DirectionsService();
      // const directionsRenderer = new google.maps.DirectionsRenderer();

      const origin = this.state.data.visitsDetail && this.state.data.visitsDetail ? this.state.data.visitsDetail[0] : undefined;
      const destiny = this.state.data.visitsDetail ? this.state.data.visitsDetail[this.state.data.visitsDetail.length - 1] : undefined;

      directionsService.route(
        {
          origin: origin ? new google.maps.LatLng(origin.location.lat, origin.location.lng) : new google.maps.LatLng(0, 0),
          destination: destiny ? new google.maps.LatLng(destiny.location.lat, destiny.location.lng) : new google.maps.LatLng(0, 0),
          waypoints: this.state.data.visitsDetail ? this.state.data.visitsDetail.map((loc) => ({
            location: new google.maps.LatLng(loc.location.lat, loc.location.lng),
            stopover: true,
          })) : [],
          travelMode: google.maps.TravelMode.DRIVING,
          optimizeWaypoints: optimized,
        },
        (result, status) => {
          if (status === google.maps.DirectionsStatus.OK) {
            // console.log(result.routes);
            const waypointOrder = result.routes[0].waypoint_order;
            const orderedRoutes = waypointOrder.map(index => result.routes[0].legs[index]);

            result.routes[0].legs = orderedRoutes;

            if (this.state.data.visitsDetail && waypointOrder && optimized) {
              console.log("nocaeacavd")
              const orderedVisits: any = waypointOrder.map((index, idx) => {
                if (this.state.data.visitsDetail) {
                  return { ...this.state.data.visitsDetail[index], order: idx + 1 };
                }
                return {};
              });
              this.setState({
                data: {
                  ...this.state.data,
                  visitsDetail: orderedVisits,
                },
              });
              console.log(orderedVisits);
            }
            console.log(this.state.data.visitsDetail, "result")
            this.setState({
              data: {
                ...this.state.data,
                fullData: result,
              },
            });
          } else {
            console.error(`Error fetching directions ${result.routes}`);
          }
        }
      );
    } else {
      console.error("No hay visitas para calcular ruta");
      this.setState({
        data: {
          ...this.state.data,
          fullData: undefined,
        },
      });
    }
  }
  selectClient(client: Client) {
    this.setState({ filter: "" });
    this.setState({
      isDialogOpenClient: false,
      data: {
        ...this.state.data,
        selectedClient: client,
      },
    });
    this.getLocationsByClientDocument(client.document);
  }
  reorganizateOrder(overwrite: boolean = false) {
    if (this.state.data.visitsDetail) {
      console.log(this.state.data.visitsDetail, "reorganizateOrder")
      const visDetail = this.state.data.visitsDetail.sort((a: any, b: any) => {
        return a.order - 1 - (b.order - 1);
      }).map((item: any, index: number) => {
        return {
          ...item,
          order: !overwrite ? item.order : index + 1,
        };
      });

      console.log(this.state.data.visitsDetail, "reorganizateOrder")
      this.setState({
        data: {
          ...this.state.data,
          visitsDetail: visDetail
        },
      }, () => {
        this.setState({ confirmarOrdenFlag: false })
        this.calculateWaypoints(false);

      });
    }
  }
  cleanOrder() {
    if (this.state.data.visitsDetail) {
      this.setState({
        confirmarOrdenFlag: true,
        data: {
          ...this.state.data,
          visitsDetail: this.state.data.visitsDetail.map((item: any, index: number) => {
            return {
              ...item,
              order: '',
            };
          }),
          fullData: undefined,
        },
      }, () => {
        // this.calculateWaypoints();

      });
    }
  }
  reordenateOrder() {
    if (this.state.data.visitsDetail) {
      this.setState({
        data: {
          ...this.state.data,
          visitsDetail: this.state.data.visitsDetail.map((item: any, index: number) => {
            return {
              ...item,
              order: '',
            };
          }),
        },
      }, () => {
        this.setState({
          confirmarOrdenFlag: false,
        });
      });
    }
  }
  handleClickRemove(id: number) {
    if (this.state.data.visitsDetail) {
      console.log(id, this.state.data.visitsDetail, "id")
      this.setState({
        data: {
          ...this.state.data,
          visitsDetail: this.state.data.visitsDetail.filter(
            (item: any) => item.id !== id
          ),
        },
      }, () => {
        this.reorganizateOrder(true);
        // this.calculateWaypoints();
      });
    }
  }
  handleFilterChange = (e: any) => {
    this.setState(
        { filterLoc: e.target.value },
        () => {
            const { pageNum, pageSize } = this.state;
            if (pageNum !== undefined && pageSize !== undefined) {
                this.obtenerUbicaciones(pageNum, pageSize);
            } else {
                console.error('pageNum o pageSize no están definidos');
            }
        }
    );
};
  handleSubmit = async () => {
    // this.props.onNewData(this.tate.data);
    const data: any = {
      visitDateTimeSchedule: format(
        this.state.data.visitDateTimeSchedule!,
        "YYYY-MM-DDTHH:mm:ssZ"
      ),
      selectedDriver: this.state.data.selectedDriver
        ? this.state.data.selectedDriver.id
        : undefined,
      vehicleId: this.state.data.vehicleId,
      limit: this.state.data.limit,
      visitDetails: this.state.data.visitsDetail
        ? this.state.data.visitsDetail.map((item: any, index: number) => {
          console.log(item);
          return {
            clientId: item.client.id,
            visitDateTime: format(item.visitDateTime, "YYYY-MM-DDTHH:mm:ssZ"),
            location: {
              lat: item.location.lat,
              lng: item.location.lng,
            },
            obs: item.observations,
            order: item.order,
            street1: item.street1,
          };
        })
        : null,
      type: "VISIT",
    };
    console.log(data, 'Data a enviar');
    if (
      data.visitDateTimeSchedule &&
      data.selectedDriver &&
      data.visitDetails &&
      data.visitDetails.length > 0
    ) {
      console.log("Dato a enviar: ", data);
      // await getApi()
      //   .visit()
      //   .addVisit(data)
      //   .then((res) => {
      //     console.log(res, "data819");
      //     this.setState(
      //       {
      //         data: {
      //           ...this.state.data,
      //           visitDateTime: "",
      //           selectedDriver: undefined,
      //           visitsDetail: [],
      //           fullData: undefined,
      //         },
      //       },
      //       () => {
      //         this.setState({
      //           dialogOpen: true,
      //         });
      //       }
      //     );
      //   })
      //   .catch((error) => {
      //     console.log(error, "error");
      //   });
      this.props.sendData(data);
    } else {
      alert("Faltan datos por completar");
    }
  };
  handleCancel() {
    this.setState({
      data: {
        ...this.state.data,
        visitDateTimeSchedule: format(new Date(), "YYYY-MM-DDTHH:mm"),
        visitDateTime: "",
        selectedDriver: undefined,
        selectedVehicle: undefined,
        vehicleId: undefined,
        visitsDetail: [],
      },
    });
  }
  handleDialogClose() {
    this.setState({
      dialogOpen: false,
    });
  }

  onDragEnd(result: any) {
    if (!result.destination) {
      return; // Dropped outside the list
    }

    if (this.state.data.visitsDetail) {
      const items = Array.from(this.state.data.visitsDetail);
      const [reorderedItem] = items.splice(result.source.index, 1);
      items.splice(result.destination.index, 0, reorderedItem);
      console.log(items, "itemsReorder")

      // Update the 'order' field of each item with its new index
      items.forEach((item, index) => {
        item.order = index + 1;
      });

      this.setState({
        data: {
          ...this.state.data,
        },
      }, () => {
        this.reorganizateOrder(false);
      });
    }
  }


  render() {
    const defaultLocation = {
      id: 0,
      lat: 0,
      lng: 0,
      street1: "",
      client: {
        user: { name: "", email: "" },
        phone: "",
      },
    };
    let clientLocations: LocationData[] = [defaultLocation];

    if (
      this.state.data.clientLocations &&
      this.state.data.clientLocations.length > 0
    ) {
      clientLocations = this.state.data.clientLocations;
      const newLocation = {
        id: 0,
        lat: 0,
        lng: 0,
        street1: "",
        client: {
          user: {
            name: clientLocations[0].client.user.name,
            email: clientLocations[0].client.user.email,
          },
          phone: clientLocations[0].client.phone,
        },
      };
      clientLocations.push(newLocation);
    }


    const driverFromParent = (): Driver | undefined => {
      this.state.data.selectedDriver =
        this.props.data && this.props.data.selectedDriver
          ? this.props.data.selectedDriver
          : this.state.data.selectedDriver;
      return this.state.data.selectedDriver;
    };

    const setearLocation = this.state.data.locations ? this.state.data.locations.map((location, index) => {
      if (location.client === null) {
        location.client = {
          id: location.clientId,
          user: {
            name: 'Usuario sin nombre: ' + location.clientId
          }
        };
      }
      return location;
    }) : null;

    const filteredLocations = setearLocation ? setearLocation
      // .filter((loc: any) => loc.client && loc.client.user && loc.client.user.name &&
      //   (loc.client.user.name.toLocaleUpperCase().includes(this.state.filterLoc.toLocaleUpperCase()))
      //   ||
      //   (loc.street1 && loc.street1.toLocaleUpperCase().includes(this.state.filterLoc.toLocaleUpperCase())))
      .map((loc: any, index: number) => (
        <TableRow key={index}>
          <TableCell>
            {
              loc.client ? loc.client.user.name :
                (this.state.data.clients && loc.clientId) ? this.state.data.clients.find(c => c.id === loc.clientId)!.user.name : ""
            }
          </TableCell>
          <TableCell>{loc.street1 + ", " + loc.street2}</TableCell>
          <TableCell>{loc.observation ? loc.observation : 'Sin observaciones'}</TableCell>
          <TableCell>
            <Button color="primary" onClick={() => this.selectLocation(loc)}>
              {/* <Button color="primary" onClick={() => this.onChangeClientLocationSelect(loc)}> */}
              <CheckIcon />
            </Button>
          </TableCell>
        </TableRow>
      )) : (
      <button onClick={() => console.log()}>
        No se encontraron datos, haz clic aquí para ir a otro sitio
      </button>
    );

    const visitadoresTable = this.state && this.state.data && this.state.data.drivers && this.state.data.drivers
      .filter(driver => driver.user.name && driver.user.name.toLocaleUpperCase().includes(this.state.filter.toLocaleUpperCase()))
      .map(driver => (
        <TableRow key={driver.id}>
          <TableCell>{driver.user.name}</TableCell>
          <TableCell>
            <Button color="primary" onClick={() => this.selectDriver(driver)}>
              <CheckIcon />
            </Button>
          </TableCell>
        </TableRow>
      ))

    const vehiclesTable = this.state.data.selectedDriver && this.state.data.selectedDriver.vehicles
      ? this.state.data.selectedDriver.vehicles
          .filter(vehicle => `${vehicle.brand} ${vehicle.model} (${vehicle.type})`.toLocaleUpperCase().includes(this.state.filterVehicle.toLocaleUpperCase()))
          .map((vehicle, index) => (
            <TableRow key={index}>
              <TableCell>{vehicle.brand} {vehicle.model} ({vehicle.type})</TableCell>
              <TableCell>
                <Button color="primary" onClick={() => this.selectVehicle(vehicle)}>
                  <CheckIcon />
                </Button>
              </TableCell>
            </TableRow>
          ))
      : null;

    return (
      <form noValidate autoComplete="off" style={{ width: "100%" }}>
        <hr />
        <Grid container>
          <Dialog style={{ textAlign: "center" }} open={this.state.dialogOpen}>
            <DialogTitle
              style={{
                textAlign: "center",
                backgroundColor: "rgb(146, 245, 76,0.3)",
                color: "white",
              }}
            >
              Visita registrada
            </DialogTitle>
            <div
              style={{
                textAlign: "center",
                backgroundColor: "rgb(146, 245, 76,0.3)",
                padding: 4,
              }}
            >
              <Button
                style={{
                  backgroundColor: "rgb(146, 245, 76,0.8)",
                  marginBottom: 3,
                }}
                variant="contained"
                onClick={this.handleDialogClose}
              >
                Aceptar
              </Button>
            </div>
          </Dialog>
          <Grid container direction="row">
            <Paper style={{ marginBottom: "15px", padding: "15px" }}>
              {/* <h5 style={{ marginBottom: '15px' }}>Datos de Visita</h5> */}
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                <StepIndicator step={1} />
                <Typography style={{ fontWeight: 'bold', fontSize: '18px' }}>Visitador</Typography>
              </div>
              <Button
                color="primary"
                style={{ border: "1px solid #000" }}
                onClick={() => this.setState({ isDialogOpen: true })}
              >
                Seleccionar visitador <SearchIcon />
              </Button>
              {driverFromParent() && (
                <TextField
                  id="driverId"
                  label="Usuario seleccionado"
                  value={
                    this.state.data.selectedDriver
                      ? this.state.data.selectedDriver.user.name
                      : ""
                  }
                  style={{
                    width: "90%",
                  }}
                  margin="normal"
                  InputProps={{
                    disabled: true,
                  }}
                  error={!this.state.data.selectedDriver}
                />
              )}

              {this.state.data.selectedDriver && (
                <div>
                  <Button color="primary" style={{ border: '1px solid #000', marginTop: '10px' }}
                    onClick={() => this.setState({ isDialogOpenVehicle: true })}>
                    Seleccionar vehículo <SearchIcon />
                  </Button>
                  {this.state.data.selectedVehicle && (
                    <TextField
                      id="vehicleId"
                      label="Vehículo seleccionado"
                      value={this.state.data.selectedVehicle ? `${this.state.data.selectedVehicle.brand} ${this.state.data.selectedVehicle.model} (${this.state.data.selectedVehicle.type})` : ''}
                      style={{
                        width: '90%',
                      }}
                      margin="normal"
                      InputProps={{
                        disabled: true,
                      }}
                      error={!this.state.data.selectedVehicle}
                    />
                  )}
                </div>
              )}
              <Dialog
                open={this.state.isDialogOpen}
                onClose={() => this.setState({ isDialogOpen: false })}
              >
                <DialogTitle>
                  <IconButton
                    color="inherit"
                    onClick={() => {
                      this.setState({ isDialogOpen: false });
                    }}
                    aria-label="close"
                  >
                    <CloseIcon />
                  </IconButton>
                  Visitador disponible
                </DialogTitle>
                <DialogContent>
                  {this.state.data &&
                    this.state.data.drivers &&
                    this.state.data.drivers.length > 0 ? (
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>
                            <p>Nombre del visitador</p>
                            <input
                              autoFocus={true}
                              autoComplete="new-password"
                              name="search"
                              value={this.state.filter}
                              id="search"
                              placeholder="Filtrar"
                              onChange={(e) =>
                                this.setState({ filter: e.target.value })
                              }
                            />
                          </TableCell>
                          <TableCell>Seleccionar</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {visitadoresTable && visitadoresTable.length > 0 ? visitadoresTable : (
                          <Link to={{
                            pathname: `/driver`,
                          }}>
                            <Button
                              color="primary"
                            >{'Sin conductores....Crear conductor/usuario'}<AddLocation /></Button>
                          </Link>)}
                      </TableBody>
                    </Table>
                  ) : (
                    <Link to={{
                      pathname: `/driver`,
                    }}>
                      <Button
                        color="primary"
                      >{'Sin conductores....Crear conductor/usuario'}<AddLocation /></Button>
                    </Link>
                  )
                  }
                </DialogContent>
              </Dialog>

              <Dialog
                open={this.state.isDialogOpenVehicle}
                onClose={() => this.setState({ isDialogOpenVehicle: false, filterVehicle: '' })}
              >
                <DialogTitle>
                  <IconButton color="inherit" onClick={() => {
                    this.setState({ isDialogOpenVehicle: false, filterVehicle: '' });
                  }} aria-label="close">
                    <CloseIcon />
                  </IconButton>
                  Vehículos disponibles</DialogTitle>
                <DialogContent>
                  {
                    vehiclesTable && vehiclesTable.length > 0 ? (
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>
                              <p>Vehículo</p>
                              <input
                                autoFocus={true}
                                autoComplete="new-password"
                                name="searchVehicle"
                                value={this.state.filterVehicle}
                                id="searchVehicle"
                                placeholder="Filtrar"
                                onChange={(e) => this.setState({ filterVehicle: e.target.value })}
                              />
                            </TableCell>
                            <TableCell>Seleccionar</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {vehiclesTable}
                        </TableBody>
                      </Table>
                    ) : (
                      <p>No hay vehículos disponibles para este conductor.</p>
                    )
                  }
                </DialogContent>
              </Dialog>
              <hr />
              <Paper style={{ marginBottom: "15px", padding: "15px" }}>
                <h6 style={{ display: 'flex', alignItems: 'flex-start' }}><label>Distancia límite para la entrega(opcional)</label></h6>
                {
                  <TextField
                    label="Distancia en metros"
                    type="number"
                    inputProps={{ step: "1" }}
                    onChange={(e) => this.setState({
                      data: {
                        ...this.state.data,
                        limit: parseInt(e.target.value, 10)
                      }
                    })}
                    value={this.state.data.limit}
                    style={{
                      width: '90%'
                    }}
                    margin="normal"
                  />

                }
              </Paper>
            </Paper>
            <Paper style={{ marginBottom: "15px", padding: "15px" }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                <StepIndicator step={2} />
                <Typography style={{ fontWeight: 'bold', fontSize: '18px' }}>Fecha de registro</Typography>
              </div>
              <input
                id="visitDateTimeSchedule"
                type="datetime-local"
                value={
                  this.state.data.visitDateTimeSchedule
                    ? this.state.data.visitDateTimeSchedule
                    : format(new Date(), "YYYY-MM-DDTHH:mm")
                }
                onChange={(e) =>
                  this.setState({
                    data: {
                      ...this.state.data,
                      visitDateTimeSchedule: e.target.value,
                    },
                  })
                }
                required
              />
              <div style={{ marginTop: '15px' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                  <StepIndicator step={3} />
                  <Typography style={{ fontWeight: 'bold', fontSize: '18px' }}>Fecha y hora de visita</Typography>
                </div>
                <input
                  id="visitDateTime"
                  type="datetime-local"
                  value={this.state.data.visitDateTime ? this.state.data.visitDateTime : ""}
                  onChange={(e) =>
                    this.setState({
                      data: {
                        ...this.state.data,
                        visitDateTime: e.target.value,
                      },
                    })
                  }
                  required
                />
              </div>
            </Paper>

            { this.state.data.visitDateTime &&
            <Paper style={{ marginBottom: "15px", padding: "15px" }}>
              {
                this.state.data.visitDateTime &&
                <div>
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                    <StepIndicator step={4} />
                    <Typography style={{ fontWeight: 'bold', fontSize: '18px' }}>Destino</Typography>
                  </div>
                  {
                    this.props.data && this.props.data.clients &&
                    <Link to={{
                      pathname: `/addlocation`,
                      state: this.props.data.clients
                    }}>{'Nueva dirección (opcional)'}<AddLocation /></Link>
                  }
                </div>
              }
              <Grid container direction="row" alignItems="baseline">
                <Grid item md={4}>
                  {/* {
                    this.state.data.visitDateTime && !this.state.data.newAddress &&
                    <Button color="primary" style={{ border: '1px solid #000' }} onClick={() => this.setState({ isDialogOpenLoc: true },
                      () => {
                        if (this.props.data && this.props.data.selectedClient) {
                          this.setState({
                            filterLoc: this.props.data.selectedClient.user.name
                          })
                        }
                      }
                    )}>
                      Seleccionar <SearchIcon />
                    </Button>

                  } */}
                  {
                    this.state.data  ? (
                      this.state.data.visitDateTime ? (
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>
                              <p style={{ margin: 0 }}>Clientes</p>
                              <TextField
                                autoComplete="new-password"
                                name="search"
                                value={this.state.filterLoc}
                                id="searchName"
                                placeholder="Filtrar"
                                onChange={this.handleFilterChange}
                                style={{ padding: 0 }}
                                autoFocus={true}
                              />
                            </TableCell>
                            <TableCell>
                              <p style={{ margin: 0 }}>Direccion</p>
                            </TableCell>
                            <TableCell>Observaciones</TableCell>
                            <TableCell>Seleccionar</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <>
                            {Array.isArray(filteredLocations) && filteredLocations.length > 0 ? (
                              filteredLocations
                            ) : (
                              this.props.data && this.props.data.clients &&
                              <Link to={{
                                pathname: `/addlocation`,
                                state: this.props.data.clients
                              }}>
                                <Button
                                  style={{ border: '1px solid #000' }}
                                  color="primary"
                                >{'No se encontró la dirección, crear una nueva'}<AddLocation /></Button>
                              </Link>
                            )}
                          </>
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              count={this.state.data ? this.state.totalItems : 0}
                              page={this.state.pageNum}
                              rowsPerPage={this.state.pageSize}

                              onChangePage={(event, newPage) => this.setState({ pageNum: newPage }, () => this.obtenerUbicaciones(this.state.pageNum, this.state.pageSize))}
                              onChangeRowsPerPage={
                                (event) =>
                                  this.setState({ pageSize: +event.target.value, pageNum: 0 },
                                    () => this.obtenerUbicaciones(this.state.pageNum, this.state.pageSize))}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                      )
                      : (
                        null
                      )
                    ) : (
                      <CircularProgress />
                    )}
                </Grid>
              </Grid>
              <Dialog
                open={this.state.isDialogOpenLoc}
                onClose={() => this.setState({ isDialogOpenLoc: false, filterLoc: '' })}
                maxWidth={false}
              >
                <DialogTitle>
                  <IconButton color="inherit" onClick={() => this.setState({ isDialogOpenLoc: false, filterLoc: '' })} aria-label="close">
                    <CloseIcon />
                  </IconButton>
                  Ubicaciones/sucursales de clientes</DialogTitle>
                <DialogContent style={{ maxWidth: 'none' }}>
                  {this.state.data ? (
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>
                            <p style={{ margin: 0 }}>Clientes</p>
                            <TextField
                              autoComplete="new-password"
                              name="searchName"
                              value={this.state.filterLoc}
                              id="searchName"
                              placeholder="Filtrar"
                              onChange={(e) => this.setState(
                                { filterLoc: e.target.value },

                              )}
                              style={{ padding: 0 }}
                              autoFocus={true}
                            />
                          </TableCell>
                          <TableCell>
                            <p style={{ margin: 0 }}>Direccion</p>
                          </TableCell>
                          <TableCell>Observaciones</TableCell>
                          <TableCell>Seleccionar</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <>
                          {Array.isArray(filteredLocations) && filteredLocations.length > 0 ? (
                            filteredLocations
                          ) : (
                            this.props.data && this.props.data.clients &&
                            <Link to={{
                              pathname: `/addlocation`,
                              state: this.props.data.clients
                            }}>
                              <Button
                                style={{ border: '1px solid #000' }}
                                color="primary"
                              >{'No se encontró la dirección, crear una nueva'}<AddLocation /></Button>
                            </Link>
                          )}
                        </>
                      </TableBody>
                      <TableFooter>
                        <TableRow>
                          <TablePagination
                            count={this.state.data ? this.state.totalItems : 0}
                            page={this.state.pageNum}
                            rowsPerPage={this.state.pageSize}

                            onChangePage={(event, newPage) => this.setState({ pageNum: newPage }, () => this.obtenerUbicaciones(this.state.pageNum, this.state.pageSize))}
                            onChangeRowsPerPage={
                              (event) =>
                                this.setState({ pageSize: +event.target.value, pageNum: 0 },
                                  () => this.obtenerUbicaciones(this.state.pageNum, this.state.pageSize))}
                          />
                        </TableRow>
                      </TableFooter>
                    </Table>
                  ) : (
                    <CircularProgress />
                  )}
                </DialogContent>
              </Dialog>
            </Paper>
            }
            <Grid container direction="row" alignContent="center" alignItems="center" style={{ marginBottom: '15px', backgroundColor: '' }}>
              <Grid item md={2}>
                {
                  this.state.data.visitDateTime && this.state.data.newAddress && <div>
                    <Button color="primary" style={{ border: '1px solid #000' }} onClick={() => this.setState({ isDialogOpenClient: true })}>
                      Seleccionar clientes <SearchIcon />
                    </Button>
                  </div>
                }
              </Grid>
              <Grid item md={4} style={{ marginRight: '15px' }}>
                {
                  this.state.data.visitDateTime && this.state.data.newAddress &&
                  <TextField
                    id="clientId"
                    label={this.state.data.selectedClient ? "Cliente seleccionado:" : "Cliente no seleccionado"}
                    value={this.state.data.selectedClient && this.state.data.selectedClient.user ? this.state.data.selectedClient.user.name : ''}
                    margin="normal"
                    style={{ border: this.state.data.selectedClient ? 'none' : 'red solid 1px', width: '100%' }}
                    InputProps={{
                      disabled: true,
                    }}
                    required
                    error={!this.state.data.selectedClient}
                  />

                }
                {/* <Dialog
                                    open={this.state.isDialogOpenClient}
                                    onClose={() => this.setState({ isDialogOpenClient: false, filter: '' })}
                                >
                                    <DialogTitle>
                                        <IconButton color="inherit" onClick={() => this.setState({ isDialogOpenClient: false, filter: '' })} aria-label="close">
                                            <CloseIcon />
                                        </IconButton></DialogTitle>
                                    <DialogContent>
                                        <LocationComponent 
                                        data={null} 
                                        clients={this.props.data && this.props.data.clients ? this.props.data.clients : []} 
                                        />
                                    </DialogContent>
                                </Dialog> */}
              </Grid>
            </Grid>
          </Grid>

          <Paper style={{ marginBottom: "15px", padding: "15px", width: '100%' }}>
            <hr />
            <EnhancedMap
              center={this.state.center}
              zoom={this.props.config.maps.startingLocation.zoom}
              destiny={
                this.state.data.visitsDetail &&
                  this.state.data.visitsDetail.length > 0
                  ? this.state.data.visitsDetail
                  : this.state.data.destiny
              }
              // origin={this.state.data.origin}
              directions={this.state.data.fullData}
              handleDragEnd={this.handleDragEnd}
              handleOnClick={this.handleOnClick}
            ></EnhancedMap>
          </Paper>

          <Paper style={{ marginBottom: "15px", padding: "15px", width: '100%' }}>
            <hr />
            <Grid container direction="row" style={{ display: 'flex', alignItems: 'center' }}>
              {/* <pre>{JSON.stringify(this.state.data.visitsDetail, null, 2)}</pre> */}
              <h6>Clientes a Visitar</h6>
              <Button title="" color="primary" onClick={this.cleanOrder}><ClearAll /> Reasignar orden manualmente</Button>
              {this.state.confirmarOrdenFlag &&
                <Button title="" color="primary" onClick={() => this.reorganizateOrder()}><CheckCircleIcon /> Confirmar Orden</Button>
              }

              <Button color="primary" onClick={() => this.calculateWaypoints(true)}><LocationSeraching /> Optimizar ruta</Button>
            </Grid>
            <div style={{ width: '100%' }}>
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                  <div style={{ width: '30%' }}><label style={{ fontSize: '13px' }}>Cliente</label></div>
                  <div style={{ width: '15%' }}><label style={{ fontSize: '13px' }}>Fecha</label></div>
                  <div style={{ width: '40%' }}><label style={{ fontSize: '13px' }}>Obs</label></div>
                  <div style={{ width: '10%' }}><label style={{ fontSize: '13px' }}>Orden</label></div>
                  <div style={{ width: '5%' }}><label style={{ fontSize: '13px' }}>Acciones</label></div>
                </div>
              </div>
              <div>
                <DragDropContext onDragEnd={this.onDragEnd}>
                  <Droppable droppableId="droppable">
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                      >
                        {(this.state.data.visitsDetail) ? (
                          this.state.data.visitsDetail
                            .map((cli: any, index: number) => (
                              <Draggable key={cli.id} draggableId={`${cli.id}`} index={index}>
                                {(prov: any) => (
                                  <div
                                    ref={prov.innerRef}
                                    {...prov.draggableProps}
                                    {...prov.dragHandleProps}
                                  >
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', fontSize: '11px', border: '1px solid black', borderRadius: '5px' }}>
                                      <div style={{ width: '30%', marginLeft: '2px' }}>
                                        {cli.client.user.name}
                                      </div>
                                      <div style={{ width: '15%', marginLeft: '2px' }}>
                                        {cli.visitDateTime}
                                      </div>
                                      <div style={{ width: '40%', marginLeft: '2px' }}>
                                        <TextField
                                          id="observations"
                                          placeholder="Observaciones"
                                          multiline
                                          rows={3}
                                          value={cli.observations}
                                          onChange={(event) =>
                                            this.handleObservationsChange(event, cli)
                                          }
                                          InputProps={{
                                            style: {
                                              fontSize: '11px',
                                            }
                                          }}
                                          style={{
                                            width: "90%",
                                          }}
                                          margin="normal"
                                        />
                                      </div>
                                      <div style={{ width: '10%', marginLeft: '2px' }}>
                                        <TextField
                                          id="order"
                                          placeholder="Orden"
                                          type="text"
                                          value={cli.order}
                                          onChange={(event) => this.handleOrderChange(event, cli)}
                                          style={{
                                            width: "90%",
                                          }}
                                          InputProps={{
                                            style: {
                                              fontSize: '11px',
                                            }
                                          }}
                                          margin="normal"
                                        />
                                      </div>
                                      <div style={{ width: '5%', marginLeft: '2px' }}>
                                        <IconButton
                                          aria-label="Visitados"
                                          title="Visitados"
                                          onClick={() =>
                                            cli.client && this.handleClickRemove(cli && cli.id ? cli.id : 0)
                                          }
                                        >
                                          <DeleteIcon />
                                        </IconButton>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </Draggable>
                            ))
                        ) : (
                          <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <p>No hay datos</p>
                          </div>
                        )}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>

              </div>
            </div>
            {/*<AsyncTable
              columnDefinition={this.state.table.columnData}
              title={''}
              showHeader={false}
              data={this.state.data.visitsDetail || []}
              defaultOrder={{
                name: "order",
                direction: "asc",
              }}
            />
            */}

            <br />
          </Paper>
        </Grid>
        <div style={{ display: "flex", flexDirection: "row-reverse" }}>
          <Paper style={{ marginBottom: "15px", padding: "15px" }}>
            <Button onClick={this.handleCancel}> Cancelar </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={this.handleSubmit}
          >
            {" "}
            Guardar{" "}
          </Button>
          </Paper>
        </div>
      </form>
    );
  }
}

export default compose<any, RouteSelectorProps>(
  withProps((props: RouteSelectorProps) => {
    return {
      googleMapURL: `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${props.config.maps.key}`,
      loadingElement: <div style={{ height: "400px" }} />,
    };
  }),
  withScriptjs
)(RouteSelectorVisit);



// WEBPACK FOOTER //
// ./src/components/routeSelectorVisit.tsx